import { Divider } from '@advanza/ui'
import Page from 'components/ui/Page'
import WinbackOfferSettingsList from 'components/winbackoffersettings/WinbackOfferSettingsList'
import { useCurrentCountry } from 'hooks/miscHooks'

const WinbackOfferSettingsPage = () => {
    const country = useCurrentCountry()

    return (
        <Page title={`Winback Offer Settings ${country}`}>
            <div className="container">
                <Divider />
                <h1>Winback Offer Settings {country}</h1>
                <WinbackOfferSettingsList />
            </div>
        </Page>
    )
}

export default WinbackOfferSettingsPage
